<div class="test-container">
    <input [(ngModel)]="coords" />
    <div style="display: flex; gap: 15px;">
        <button (click)="sendForm()">Calcular</button>
        <button (click)="getRouteInfo()">Info</button>
    </div>
    <div style="display: flex; gap: 15px;">
        @if (polylines){
            <pre>{{ polylines | json }}</pre>
        }
        @if (instructions){
            <pre class="big">{{ instructions | json }}</pre>
        }
    </div>
</div>